export class UniBrandSubReport {
    UniBrandObjectID: number;
    UniSubreportID: any;
    Label: string;
    ProductionReportCalculationID: number;
    VatCode?: any;
    VatRate: number;
    VatInclExclNvtTC: string;
    RepairPartnerID?: any;
    Description?: any;
    CurrencyTC: string;
    PrintParts: boolean;
    CreatedDate: Date;
    CreatedByUserId: number;
    Group: string;
    Maximization?: any;
    ExternalRefId?: any;

    public constructor(init?: Partial<UniBrandSubReport>) {
        Object.assign(this, init);
    }
}

